import { format } from 'date-fns';

import { getEnvRequired } from '../../shared/utilities/env';
import { getAuthToken } from '../login/operations';

import {
    DiscussionIsResponseRequiredState,
    DiscussionItem,
    Message,
    MessagesGroupByDate,
} from './types';

export const generateSendingMessageId = (): string => {
    return String(new Date().getTime());
};

export const addAttachmentLinkToMessage = (message: Message): Message => ({
    ...message,
    attachments: message.attachments.map((attachment) => ({
        ...attachment,
        link: `${getEnvRequired('DISCUSSION_API_URL')}/discussions/messages/${
            message.id
        }/attachments/${attachment.id}?jwt=${getAuthToken()}`,
    })),
});

export const groupDiscussionItemByDate = (
    acc: MessagesGroupByDate,
    discussionItem: DiscussionItem,
): MessagesGroupByDate => {
    const date = format(discussionItem.sendDate, 'yyyy-MM-dd');
    acc[date] = [...(acc[date] || []), discussionItem];
    return acc;
};

export const getIsResponseRequiredState = (
    isLastMessageFromTraveller = false,
    isResponseRequired: boolean,
): DiscussionIsResponseRequiredState => {
    if (isLastMessageFromTraveller && isResponseRequired) {
        return 'TO_MARK_AS_NO_RESPONSE_REQUIRED';
    }
    if (isLastMessageFromTraveller && !isResponseRequired) {
        return 'MANUALLY_MARKED_AS_NO_RESPONSE_REQUIRED';
    }
    return 'AUTOMATICALLY_MARKED_AS_NO_RESPONSE_REQUIRED';
};
